<div class="ftp">
  <div class="ftp__search-wrap">
    <i class="fas fa-search ftp__search-icon"></i>
    <input
      type="text"
      class="ftp__search form-control"
      [(ngModel)]="searchTerm"
      [placeholder]="placeholder | translate"
      (input)="applySearch()"
      (click)="$event.stopPropagation()" />
  </div>

  <div class="ftp__tree" *ngIf="visibleTree.length; else emptyTpl">
    <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: visibleTree, depth: 0 }"></ng-container>
  </div>

  <ng-template #emptyTpl>
    <div class="ftp__empty">{{ emptyMessage | translate }}</div>
  </ng-template>

  <ng-template #nodeTpl let-nodes let-depth="depth">
    <ng-container *ngFor="let n of nodes">
      <div class="ftp__node"
           [class.ftp__node--selectable]="isSelectable(n)"
           [class.ftp__node--selected]="n.key === selectedKey"
           [style.--depth]="depth">
        <span class="ftp__chevron"
              *ngIf="n.components && n.components.length; else chevronPlaceholder"
              (click)="toggleExpand(n); $event.stopPropagation()">
          <i class="fas" [class.fa-chevron-right]="!expandedKeys.has(n.key)" [class.fa-chevron-down]="expandedKeys.has(n.key)"></i>
        </span>
        <ng-template #chevronPlaceholder>
          <span class="ftp__chevron ftp__chevron--placeholder" aria-hidden="true"></span>
        </ng-template>
        <span class="ftp__name" (click)="selectNode(n)">{{ n.name || n.key }}</span>
      </div>
      <ng-container *ngIf="expandedKeys.has(n.key) && n.components && n.components.length">
        <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: n.components, depth: depth + 1 }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>
